<template>

	<div :class="{'metric': !!metric}">

		<p class="tags-info" v-if="metric!=='custom'">
			<strong class="tag-copy" @click="copyToClipboard('[[project]]')">[[project]]</strong> &amp; <strong class="tag-copy" @click="copyToClipboard('[[date]]')">[[date]]</strong> will be replaced with the project name and current date respectively (adding the date will also reveal a dropdown to select the date format).<br>
			If you'd like to add tags from your Report Custom Info CSV <span @click="action('addCustomTags')" class="add-custom-tags">click here for more info</span>.
		</p>

		<p class="tags-info" v-if="metric&&metric==='custom'">
			<strong>Metric Label, Value, Previous Value, Change, Previous Value Label</strong> can use tags. <strong class="tag-copy" @click="copyToClipboard('[[project]]')">[[project]]</strong> &amp; <strong class="tag-copy" @click="copyToClipboard('[[date]]')">[[date]]</strong> will be replaced with the project name and current date respectively (adding the date will also reveal a dropdown to select the date format).<br>
			If you'd like to add tags from your Report Custom Info CSV <span @click="action('addCustomTags')" class="add-custom-tags">click here for more info</span>.

		<div class="setting-group" v-if="textEditorHasDateTag">
			<label class="input-label">Date Format</label>
			<v-select
				v-model="theDateFormat"
				:options="dateFormatOptions"
				:reduce="(option) => option.value"
				label="label"
				class="date-format-select"
				:clearable="false"
				placeholder="Defaults to March 19, 2024 format"
				:append-to-body="true"
			/>
		</div>

	</div>

</template>

<script>
export default {
	name: 'Taginfo',
	props: {
		textEditorHasDateTag: {
			type: Boolean,
			default: false
		},
		dateFormat:{
			type: String,
			default: null
		},
		dateFormatOptions: {
			type: Array,
			default: () => []
		},
		metric:{
			type: String,
			default: ''
		}
	},
	watch: {

		theDateFormat(newVal) {

			this.$emit('dateFormatUpdated', newVal);

		}
	},
	data() {

		return {
			theDateFormat: null
		}

	},
	methods: {

		action(type) {

			this.$emit('action', type);

		},
		
		copyToClipboard(text) {
			navigator.clipboard.writeText(text)
				.then(() => {
					this.$snotify.success(`Copied ${text} to clipboard`);
				})
				.catch(err => {
					this.$snotify.error('Failed to copy to clipboard');
					console.error('Could not copy text: ', err);
				});
		}

	},
	created() {

		this.theDateFormat = this.dateFormat || this.dateFormatOptions[0].value;

	}

}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';

.tags-info {
	margin: 1rem 0 0;
	font-size: 0.85rem;
	color: #666;
	font-style: italic;
}
.metric {
	.tags-info {
		margin: 0;
	}
}
.setting-group {
	margin: 1rem 0 0;
	label {
		display: block;
		margin-bottom: 0.15rem;
		font-size: 14px;
		opacity: 0.8;
		font-weight: normal;
	}
}

.add-custom-tags {
	cursor: pointer;
	color: @formDefaultColour;
	font-weight: @bold;
	&:hover {
		text-decoration: underline;
	}
}

.tag-copy {
	cursor: pointer;
	&:hover {
		text-decoration: underline;
		color: @formDefaultColour;
	}
}

.what-is-this {
	cursor: pointer;
	color: @darkContrast;
	font-weight: @bold;
	&:hover {
		text-decoration: underline;
	}
}
</style>